import { render, staticRenderFns } from "./DisclaimerText.vue?vue&type=template&id=4fb87bda&scoped=true&"
import script from "./DisclaimerText.vue?vue&type=script&lang=js&"
export * from "./DisclaimerText.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerText.vue?vue&type=style&index=0&id=4fb87bda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb87bda",
  null
  
)

export default component.exports